import React from 'react';
import moment from 'moment';
import momentDurationFormatSetup from 'moment-duration-format';
import PrevArrow
  from '../components/slider_components/slider_prev_arrow/PrevArrow';
import NextArrow
  from '../components/slider_components/slider_next_arrow/NextArrow';
import Icon from 'antd/es/icon';
import Loadable from 'react-loadable';
import {GET_WALLET_DATA} from '../apollo/schema';
import {client} from '../apollo/apolloClient';

momentDurationFormatSetup(moment);

export const DEFAULT_AVATAR_URL = 'https://assets-new.medcampus.io/assets/images/default-avatar.png';

export const cardSliderConfig = {
  className: 'slider variable-width',
  dots: false,
  arrows: true,
  infinite: true,
  slidesToShow: 4,
  slidesToScroll: 4,
  variableWidth: true,
  prevArrow: <PrevArrow/>,
  nextArrow: <NextArrow/>,
  responsive: [
    {
      breakpoint: 1250,
      settings: {
        slidesToShow: 3,
        slidesToScroll: 3,
        arrows: false,
        dots: true,
      },
    },
    {
      breakpoint: 1024,
      settings: {
        slidesToShow: 3,
        slidesToScroll: 3,
        arrows: false,
        dots: true,
      },
    },
    {
      breakpoint: 850,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 2,
        arrows: false,
        dots: true,
      },
    },
    {
      breakpoint: 570,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1,
        arrows: false,
        dots: true,
      },
    },
  ],
};

export const cardSliderConfig1 = (i) => {
  return {
    className: 'slider variable-width',
    dots: false,
    arrows: true,
    infinite: true,
    centerMode: false,
    slidesToShow: i,
    slidesToScroll: i,
    variableWidth: true,
    prevArrow: <PrevArrow/>,
    nextArrow: <NextArrow/>,
    responsive: [
      {
        breakpoint: 1250,
        settings: {
          arrows: false,
          dots: true,
        },
      },
      {
        breakpoint: 1200,
        settings: {
          slidesToShow: i < 3 ? i : 3,
          slidesToScroll: i < 3 ? i : 3,
          arrows: false,
          dots: true,
        },
      },
      {
        breakpoint: 850,
        settings: {
          slidesToShow: i < 2 ? i : 2,
          slidesToScroll: i < 2 ? i : 2,
          arrows: false,
          dots: true,
        },
      },
      {
        breakpoint: 570,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          arrows: false,
          dots: true,
        },
      },
    ],
  };
};

export const covertTotime = function(time) {
  return moment.unix(time).format('DD/MM/YY hh:mm');
};

export const serumData = function() {
  return new Promise(function(resolve, reject) {
    client.query({
      query: GET_WALLET_DATA,
    }).then(result => {
      resolve(result.data.getWallet);
    }).catch(error => {
      reject(error);
    });
  });
};

export const getTimelineIcon = (icon) => {

  switch (icon) {
    case 1:
      // Arena
      return <Icon style={{fontSize: '16px'}} type="book"/>;
    case 2:
      // Challenge
      return <Icon style={{fontSize: '16px'}} type="book"/>;
    case 3:
      // Bookmark
      return <Icon style={{fontSize: '16px'}} type="book"/>;
    case 4:
      // PrepMed
      return <Icon style={{fontSize: '16px'}} type="book"/>;
    case 5:
      // Daily Login
      return <Icon style={{fontSize: '16px'}} type="book"/>;
    case 6:
      // Sign up
      return <Icon style={{fontSize: '16px'}} type="book"/>;
    case 7:
      // Referral
      return <Icon style={{fontSize: '16px'}} type="book"/>;
    case 8:
      // Share
      return <Icon style={{fontSize: '16px'}} type="book"/>;
      // case 9:
      //   // Trophy
      //   return <FitImage
      //       source={{uri: 'https://assets-new.medcampus.io/app/assets/images/trophy-30x30.png'}}
      //       style={styles.image}/>;
      // case 10:
      //   // Redeem
      //   return <Icon style={{ fontSize: '16px' }}
      //                type="book" />;
      // case 11:
      //   // MedPass
      //   return <FitImage
      //     source={{uri: 'https://assets-new.medcampus.io/assets/images/medpass-icon.png'}}
      //     style={styles.image}/>;
      // case 12:
      //   // Gold Medal
      //   return <FitImage
      //       source={{uri: 'https://assets-new.medcampus.io/app/assets/images/gold-medal-30x30.png'}}
      //       style={styles.image}/>;
      // case 13:
      //   // Silver Medal
      //   return <FitImage
      //       source={{uri: 'https://assets-new.medcampus.io/app/assets/images/silver-medal-30x30.png'}}
      //       style={styles.image}/>;
      // case 14:
      //   // Bronze Medal
      //   return <FitImage
      //       source={{uri: 'https://assets-new.medcampus.io/app/assets/images/bronze-medal-30x30.png'}}
      //       style={styles.image}/>;
      // case 15:
      //   // Level up
      //   return <Icon style={{ fontSize: '16px' }} type='Feather'
      //                name='trending-up'/>;
      // case 16:
      //   // Life
      //   return <FitImage
      //       source={{uri: 'https://assets-new.medcampus.io/app/assets/images/heart-30x30.png'}}
      //       style={styles.image}/>;
    default:
      return null;
  }
};
export const createMarkup = function(html) {
  let data = modifyCdn(html);
  data = modifyTable(data);
  return {__html: data};
};

export const getIdFromSlug = function(pathName) {
  if (pathName === undefined) {
    return '';
  } else {
    let splittedPathName = pathName.split('-');
    return splittedPathName[splittedPathName.length - 1];
  }
};

export const getChallengeIdFromUrl = () => {
  let splittedUrl = window.location.pathname.split('/');
  return splittedUrl[splittedUrl.length - 1];
};

export const getChallengeIdFromSlug = () => {
  let splittedUrl = window.location.pathname.split('-');
  return splittedUrl[splittedUrl.length - 1];
};

export const getIdFromUrl = function(pathName) {
  let splittedPathName = pathName.split('/');
  return splittedPathName[splittedPathName.length - 1];
};

export const getAvatarUrl = function(url) {
  return (url === '' || url === undefined ||
      url.includes('platform-lookaside.fbsbx.com')) ? DEFAULT_AVATAR_URL : url;
};

export const getTime = function(time) {
  let duration = moment.duration(time, 'seconds');
  return duration.format('mm:ss');
};

export const getMilliSeconds = seconds => {
  return seconds === undefined ? 0 : parseInt(seconds) * 1000;
};

export const getExpiryDays = function(endTime) {
  return moment(endTime * 1000).diff(moment(), 'days');
};

export const getChallengeStatus = function(startTime, testMode) {
  let now = moment().utc().unix();
  if (testMode) {
    if (testMode !== 'GrandTestMode' && startTime > now) {
      return 0;
    } else if (startTime > now + 86400) {
      return 0;
    }
  } else if (startTime > now) {
    //coming soon
    return 0;
  }
  return 1;
};

export const getExpiryStatus = function(endTime, inPage) {
  let now = moment().utc().unix();
  if (endTime < now) {
    return 'Practice';
  }
  let days = moment(endTime * 1000).diff(moment(), 'days');
  if (days === 0) {
    return inPage ? 'Expiring today' : 'Today';
  }

  if (days === 1) {
    return inPage ? 'Expires tomorrow' : 'Tomorrow';
  } else {
    return inPage ? 'Expires in ' + days + ' days' : days + ' days';
  }
};

export const getExpiryDate = function(endTime) {
  return moment.unix(endTime).format('MMM DD, YYYY');
};

export const isExpired = (expiryDate = 0) => {
  const now = moment().utc().unix();
  return now > expiryDate;
};

export const getDurationFromNow = function(timeStamp) {
  if (timeStamp !== null && timeStamp !== undefined) {
    return moment.unix(timeStamp).fromNow();
  } else return 0;
};

export const parseJwt = function(token) {
  let base64Url = token.split('.')[1];
  return JSON.parse(window.atob(base64Url));
};

export const getPrime = (token) => {
  let base64Url = token.split('.')[1];
  return JSON.parse(window.atob(base64Url)).is_prime;
};

export const WINDOW_WIDTH = window.innerWidth;

export const modifyCdn = function(link) {
  if (link === undefined) {
    return '';
  } else {
    let newLink = link.replace('s3.ap-south-1.amazonaws.com/copy-medcampus-v2/', 'store-new.medcampus.io/')
    return newLink.replace('s3.ap-south-1.amazonaws.com/medcampus-v2/', 'store-new.medcampus.io/');
  }
};

export const modifyTable = function(data) {
  let modifiedData = data.replaceAll('<table', '<div class=\'table-responsive\'><table');
  modifiedData = modifiedData.replaceAll('</table>', '</table></div>');
  return modifiedData;
};

export const getTimeAllotted = (basis, totalTime) => {
  let time = moment.duration(totalTime, 'seconds').format('h:mm');
  let timeString = '';
  if (!time.includes(':')) {
    timeString = time + ' mins';
  } else {
    let splitTime = time.split(':');
    if (basis === 3) {
      timeString += '7 hr';
    } else if (basis === 4) {
      timeString += '8 hr';
    } else {
      if (splitTime[0] !== '00') {
        timeString += splitTime[0] === '1' ?
            splitTime[0] + ' hr ' :
            splitTime[0] + ' hrs ';
      }
      if (splitTime[1] !== '00') {
        timeString += splitTime[1] + ' mins';
      }
    }
  }
  return timeString;
};

export const getTimeTaken = (totalTime) => {
  let time = moment.duration(totalTime, 'seconds').format('h:mm');
  let hrs = time.split(':').length > 1;

  let timeString = '';
  if (hrs) {
    timeString = (time.split(':')[0] === '1' ?
        time.split(':')[0] + ' hr ' :
        time.split(':')[0] + 'hrs ') + time.split(':')[1] + ' mins';
  } else {
    timeString = time + ' mins';
  }
  return timeString;
};

export const convertMsToHMS = ms => {
  return moment.duration(ms, 'milliseconds').format('h:mm:ss');
};

export const convertUnixToDMY = (unixTime, type) => {
  if (type === 1) {
    return moment.unix(unixTime).format('DD/MM/YYYY');
  } else if (type === 2) {
    return moment.unix(unixTime).format('MMM DD, YYYY');
  } else {
    return moment.unix(unixTime).format('MMM DD');
  }
};

export const getUserPrimeData = token => {
  if (token === null) {
    return {
      isPrime: false,
      videoPass: false,
      testPass: false,
    };
  } else {
    const {
      is_prime: isPrime = false,
      video_pass: videoPass = false,
      test_pass: testPass = false,
    } = parseJwt(token);
    return {isPrime, videoPass, testPass};
  }
};

export const isArraysEqual = (arr1, arr2) => {
  if (arr1.length !== arr2.length) return false;
  for (let i = arr1.length; i--;) {
    if (arr1[i] !== arr2[i])
      return false;
  }
  return true;
};

export const getCaterogyFromUrl = url => {
  let splitUrl = url.split('/');
  return splitUrl[splitUrl.length - 2];
};

export const capitalizeString = string => {
  if (string === '' || string === undefined || string === null) {
    return '';
  } else return string.toLowerCase().replace(/\b./g, function(a) {
    return a.toUpperCase();
  });
};

export const slugify = string => {
  const a = 'àáäâãåăæçèéëêǵḧìíïîḿńǹñòóöôœṕŕßśșțùúüûǘẃẍÿź·/_,:;';
  const b = 'aaaaaaaaceeeeghiiiimnnnoooooprssstuuuuuwxyz------';
  const p = new RegExp(a.split('').join('|'), 'g');
  return string.toString().
      toLowerCase().
      replace(/\s+/g, '-') // Replace spaces with -
      .replace(p, c => b.charAt(a.indexOf(c))) // Replace special characters
      .replace(/&/g, '-and-') // Replace & with ‘and’
      .replace(/[^\w\-]+/g, '') // Remove all non-word characters
      .replace(/\-\-+/g, '-') // Replace multiple - with single -
      .replace(/^-+/, '') // Trim - from start of text
      .replace(/-+$/, ''); // Trim - from end of text
};

export const unSlugify = string => {
  return string.replace(/-/g, ' ');
};

export const unSlugifyCaps = string => {
  return string.replace(/-/g, ' ').toUpperCase();
};

export const nFormatter = (num, digits) => {
  let si = [
    {value: 1, symbol: ''},
    {value: 1E3, symbol: 'K'},
    {value: 1E6, symbol: 'M'},
    {value: 1E9, symbol: 'G'},
    {value: 1E12, symbol: 'T'},
    {value: 1E15, symbol: 'P'},
    {value: 1E18, symbol: 'E'},
  ];
  let rx = /\.0+$|(\.[0-9]*[1-9])0+$/;
  let i;
  for (i = si.length - 1; i > 0; i--) {
    if (num >= si[i].value) {
      break;
    }
  }
  return (num / si[i].value).toFixed(digits).replace(rx, '$1') + si[i].symbol;
};

export const convertMinsToHrsMins = (minutes) => {
  let h = Math.floor(minutes / 60);
  let m = minutes % 60;
  h = h < 10 ? '0' + h : h;
  m = m < 10 ? '0' + m : m;
  return h + ':' + m;
};

export const debounce = (func, wait, immediate = false) => {
  let timeout;
  return (...args) => {
    const later = () => {
      timeout = null; // added this to set same behaviour as ES5
      if (!immediate) func(...args); // this is called conditionally, just like in the ES5 version
    };
    const callNow = immediate && !timeout;
    clearTimeout(timeout);
    timeout = setTimeout(later, wait);
    if (callNow) func(...args);
  };
};

export const throttle = (func, interval) => {
  let timeout;
  return function() {
    let context = this, args = arguments;
    let later = function() {
      timeout = false;
    };
    if (!timeout) {
      func.apply(context, args);
      timeout = true;
      setTimeout(later, interval);
    }
  };
};

export const getBlockArray = basis => {
  let arr = [];
  switch (basis) {
    case 1:
      arr.push(1, 2, 3);
      break;
    case 3:
      arr.push(1, 2, 3, 4, 5, 6, 7);
      break;
    case 4:
      arr.push(1, 2, 3, 4, 5, 6, 7, 8);
      break;
    default:
      arr.push(1);
      break;
  }
  return arr;
};

export const getComponent = namedComponent => Loadable({
  loader: () => import('./../pages/index'),
  loading: () => '',
  render(loaded, props) {
    const Component = loaded[namedComponent];
    return <Component {...props}/>;
  },
});

export const getPrevSearchString = module => {
  const tempKey = module + '-search-filter';
  const tempSS = localStorage.getItem(tempKey);
  return tempSS === null ? '' : tempSS;
};

export const getPrevSubjects = module => {
  const tempKey = module + '-subject-filter';
  const tempS = localStorage.getItem(tempKey);
  return tempS === null ? [] : JSON.parse(tempS);
};

const initFreshChat = (hideChatButton, userData) => {
  if (userData.id === '') {
    window.fcWidget.init({
      token: 'd5e74b2e-97da-47f2-a358-ff66bd5e4565',
      host: 'https://wchat.in.freshchat.com',
      config: {
        'cssNames': {
          'widget': 'custom_fc_frame',
        },
        'headerProperty': {
          'hideChatButton': hideChatButton,
        },
      },
    });
  } else {
    const {id, name, email, contactNumber, countryData: {countryCode}} = userData;
    window.fcWidget.init({
      token: 'd5e74b2e-97da-47f2-a358-ff66bd5e4565',
      host: 'https://wchat.in.freshchat.com',
      externalId: id,
      firstName: name,
      email,
      phone: contactNumber,
      phoneCountryCode: '+' + countryCode,
      config: {
        'cssNames': {
          'widget': 'custom_fc_frame',
        },
        'headerProperty': {
          'hideChatButton': hideChatButton,
        },
      },
    });
  }
};

export const initiateCall = (hideChatButton, userData) => {
  const id = 'freshchat-js-sdk';
  if (document.getElementById(id)) {
    initFreshChat(hideChatButton, userData);
  } else {
    const script = document.createElement('script');
    script.id = id;
    script.src = 'https://wchat.in.freshchat.com/js/widget.js';
    script.async = true;
    script.onload = () => initFreshChat(hideChatButton, userData);
    document.body.appendChild(script);
  }
};

const chatVisiblePaths = [
  '/',
  '/challenges',
  '/challenges/',
  '/medpixx/',
  '/medpixx',
  '/prepmed/',
  '/prepmed',
  '/mvideos/',
  '/mvideos',
  '/mnotes/',
  '/mnotes',
  '/playwin/',
  '/playwin',
  '/medpass/',
  '/medpass',
  '/features/',
  '/features',
  '/about-us',
  '/about-us/',
];

export const initiateOrDestroyChatUsingPath = userData => {
  if (process.env.NODE_ENV !== 'development') {
    const pathName = window.location.pathname;
    const hideChatButton = !chatVisiblePaths.includes(pathName);
    if (hideChatButton) {
      if (window.fcWidget && window.fcWidget.isInitialized()) {
        window.fcWidget.destroy();
      }
    } else initiateCall(hideChatButton, userData);
  }
};

export const convertDaysToMonths = (days = 0) => {
  if (30 > days) {
    return days + (1 >= days ? ' Day' : ' Days');
  } else {
    const months = (days / 30).toFixed(0);
    return months + (1 >= months ? ' Month' : ' Months');
  }
};

export function isEmptyObject(obj) {
  return obj && Object.keys(obj).length === 0 && obj.constructor === Object;
}
